import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';


import { ReactComponent as LogoWhite } from '../../assets/img/logo_esteso_wh.svg';
import { ReactComponent as Check } from '../../assets/new-icons/check_simple.svg';

import md5 from 'md5';
import axios from 'axios';
import { useFetchLogin } from '../../functions/login';

function RichiestaEffettuata() {
    const navigate = useNavigate()
    const fromPath = useSelector((user) => user.settings.path)
    const [showScroll, setShowScroll] = useState(false)
    const section = useSelector((user) => user.settings.section)
    const fetchLogin = useFetchLogin()
    const metodoAggiunto = useSelector((user) => user.settings.metodoAggiunto)
    useEffect(() => {
        fetchLogin()
    }, [])

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 120) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 120) {
            setShowScroll(false)
        }
    };
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    window.addEventListener('scroll', checkScrollTop)

    const bodyBox = {
        initial: {
            height: 0,
            bottom: -150,
            transition: {
                duration: 1.0,
                ease: [0.87, 0, 0.13, 1]
            }
        },
        animate: {
            height: '90%',
            bottom: -150,
            transition: {
                duration: 1.0,
                ease: [0.87, 0, 0.13, 1]
            }
        }
    };
    const handleTitle = () => {
        switch (fromPath) {
            case '/enrica/letture':
                return 'Autolettura inviata'
            case '/enrica/documenti':
                return 'Pagamento effettuato'
            case '/enrica/gas/fatture':
                return 'Pagamento effettuato';
            case '/enrica/profilo/aggiungi':
                return 'Nuovo metodo aggiunto'
            default:
                return 'Richiesta effettuata';
        }
    }
    const handleSubTitle = () => {
        switch (fromPath) {
            case '/enrica/letture':
                return 'Abbiamo ricevuto correttamente la tua autolettura.'

            default:
                return 'Abbiamo già inviato la tua richiesta al nostro Team che provvederà a gestirla entro 5 giorni lavorativi.';
        }
    }
    return (
        <div className='newPlan green'>
            <div className="newPlan-top">
                <header>
                    <div className="logo">
                        <LogoWhite />
                    </div>
                </header>
                <div className="text">
                    <p className="main">{handleTitle()}.</p>
                </div>
            </div>
            <div className="newPlan-bottom">
                <div className="boxSwipe">
                    <p className="labelSwipe">Perfetto</p>
                    <div className="icon">
                        <Check className="check" />
                    </div>
                </div>
                <div className="recapInfo">
                    <p className="main">
                        {handleTitle()}
                    </p>
                    <p className="label" style={{marginTop: 0}}>
                        {fromPath === '/enrica/profilo/aggiungi' && metodoAggiunto === 1 ? 'Carta di credito aggiunta correttamente.' : fromPath === '/enrica/profilo/aggiungi' && metodoAggiunto !== 1 ? "La richiesta per aggiungere come metodo di pagamento l'Iban fornito è stata inoltrata, il nostro team entro pochi giorni provvederà ad aggiungerlo." : handleSubTitle()}
                    </p>
                    <div className="buttonBox">
                        <button onClick={() => section ? navigate("/enrica/gas")  : navigate("/enrica")}>
                            <p>Home</p>
                            <ArrowForwardIos />
                        </button>
                        <button onClick={() => navigate('/enrica/movimenti')}>
                            <p>Tutti i movimenti</p>
                            <ArrowForwardIos />
                    </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RichiestaEffettuata
